import {
  addWeeks,
  endOfWeek,
  endOfYear,
  setISOWeek,
  setISOWeekYear,
  startOfDay,
  startOfWeek,
  startOfYear,
} from 'date-fns';
import {
  ForecastPeriod,
  ForecastPeriodOption,
  ForecastPeriodRange,
} from './types';

export const FORECAST_PERIOD_OPTIONS: ForecastPeriodOption[] = [
  { value: 'this_week', label: 'This week' },
  { value: 'this_year', label: 'This year' },
];

export const getForecastPeriodRange = (
  period: ForecastPeriod,
  today: Date = new Date()
): ForecastPeriodRange => {
  const weekStart = startOfWeek(today, { weekStartsOn: 1 });

  switch (period) {
    case 'this_week':
      return {
        start: weekStart,
        end: endOfWeek(today, { weekStartsOn: 1 }),
        showActuals: true,
        combineActualWithForecast: false,
      };
    case 'next_week': {
      const start = addWeeks(weekStart, 1);
      return {
        start,
        end: endOfWeek(start, { weekStartsOn: 1 }),
        showActuals: false,
        combineActualWithForecast: false,
      };
    }
    case 'next_4_weeks':
      return {
        start: weekStart,
        end: endOfWeek(addWeeks(weekStart, 3), { weekStartsOn: 1 }),
        showActuals: true,
        combineActualWithForecast: false,
      };
    case 'next_12_weeks':
      return {
        start: weekStart,
        end: endOfWeek(addWeeks(weekStart, 11), { weekStartsOn: 1 }),
        showActuals: true,
        combineActualWithForecast: false,
      };
    case 'this_year':
      return {
        start: startOfYear(today),
        end: endOfYear(today),
        showActuals: true,
        combineActualWithForecast: true,
      };
  }
};

export const weekStartDate = (year: number, week: number): Date =>
  startOfWeek(setISOWeek(setISOWeekYear(new Date(2000, 0, 4), year), week), {
    weekStartsOn: 1,
  });

export const isWeekInRange = (
  year: number,
  week: number,
  start: Date,
  end: Date
): boolean => {
  const startMs = startOfDay(start).getTime();
  const endMs = end.getTime();
  const weekMs = weekStartDate(year, week).getTime();
  return weekMs >= startMs && weekMs <= endMs;
};
